export default class CustomModalManager
{
    constructor() {
        this.transitions = {
            'transition': 'transitionend',
            'OTransition': 'oTransitionEnd',
            'MozTransition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
        };

        this.acceptedParams = [
            'closeImmediately'
        ];

        this.closeImmediately = false;
        this.closeDataElement = null;

        this.eventDelegation();
    }

    reinitialize(customSelector = '') {
        this.eventDelegation(customSelector + " ");
    }

    eventDelegation(customSelector = '') {
        document.querySelectorAll(customSelector + '[custom-modal]').forEach(item => {
            item.addEventListener('click', (event) => {
                let hideBackdrop = false;
                let showCustomBody = null;
                let currentTarget = event.currentTarget;
                let modalId = currentTarget.getAttribute('custom-modal');

                if (currentTarget.hasAttribute('custom-modal-body')) {
                    showCustomBody = currentTarget.getAttribute('custom-modal-body');
                }

                if (event.currentTarget.getAttribute('hideBackdrop')) {
                    hideBackdrop = true;
                }
                this.openModal(modalId, hideBackdrop, showCustomBody);
            })
        });

        document.querySelectorAll(customSelector + '[data-element="custom-modal-close"]').forEach(item => {
            item.addEventListener('click', (event) => {
                this._closeModalEvent(event);
            })
        });

        document.querySelectorAll(customSelector + '[data-entity="custom-modal"] [data-element="modal-close"]').forEach(item => {
            item.addEventListener('click', (event) => {
                this._closeModalEvent(event);
                this.closeDataElement = 'modal-close';
            })
        });

        document.querySelectorAll(customSelector + '[data-entity="custom-modal"] [data-container="modal-background"]').forEach(item => {
            item.addEventListener('click', (event) => {
                let modalId = event.currentTarget.closest('[data-entity="custom-modal"]').getAttribute('id');
                let modal = document.querySelector('#' + modalId);

                if(!modal.classList.contains('staticBackdrop')) {
                    this._closeModalEvent(event);
                }
            })
        })

        document.querySelectorAll(customSelector + '[custom-modal-open-onload]').forEach(item => {
            let modalId = item.closest('[data-entity="custom-modal"]').getAttribute('id');
            this.openModal('#' + modalId);
        });

        document.querySelectorAll('[data-back-behaviour]').forEach(item => {
            item.addEventListener('open-modal-on-back', (event) => {
                let hideBackdrop = false;
                let showCustomBody = null;
                let currentTarget = event.currentTarget;


                if (currentTarget.hasAttribute('custom-modal-body')) {
                    showCustomBody = currentTarget.getAttribute('custom-modal-body');
                }

                if (currentTarget.getAttribute('hideBackdrop')) {
                    hideBackdrop = true;
                }

                this.openModal(currentTarget.getAttribute('data-modal-id'), hideBackdrop, showCustomBody);
            });
        });
    }

    openModal(modalId, hideBackdropXs = false, showCustomBody = null)
    {
        this._openModal(modalId, hideBackdropXs, showCustomBody);
    }

    _openModal(modalId, hideBackdropXs = false, showCustomBody = null)
    {
        let modal = document.querySelector(modalId);
        modal.classList.add('custom-modal-open');

        if (showCustomBody !== null) {
            modal.querySelectorAll('[data-body-entity]').forEach((customBody, key) => {
                if (customBody.getAttribute('data-body-entity') === showCustomBody) {
                    customBody.classList.remove('d-none')
                } else {
                    customBody.classList.add('d-none');
                }
            });
        }

        if (!modal.classList.contains('custom-modal-bottom')) {
            document.body.classList.add('modal-open');
        }

        modal.dispatchEvent(new Event('custom-modal-show'));

        if (hideBackdropXs) {
            modal.querySelector('[data-container="modal-background"]').classList.add('hide-backdrop');
        }

        modal.addEventListener('pop-state', (e) => {
            this.closeAnimationModal(modalId);
        }, {once: true});

        setTimeout(() => {
            modal.classList.add('in');
            if (document.hidden) {
                this.initializeModal(modal, modalId);
            }
        }, 100);

        const modalDialog = modal.querySelector('.custom-modal-dialog');
        for (let transition in this.transitions) {
            if (modalDialog.style[transition] !== undefined) {
                modalDialog.addEventListener(this.transitions[transition], () => {
                    this.initializeModal(modal, modalId);
                }, {once: true});
                break;
            }
        }
    }

    initializeModal(modal, modalId) {
        modal.dispatchEvent(new Event('custom-modal-shown'));

        const myEvent = new CustomEvent('addHistoryState', {
            'detail': {
                eventId: modalId
            }
        });
        document.dispatchEvent(myEvent);
    }

    closeAnimationModal(modalId)
    {
        let modal = document.querySelector(modalId);
        let modalDialog = modal.querySelector('.custom-modal-dialog');
        for (let transition in this.transitions) {
            if (modalDialog.style[transition] !== undefined) {
                modalDialog.addEventListener(this.transitions[transition], () => {
                    this.removeVisibility(modal);
                }, {once: true});
                break;
            }
        }

        modal.classList.remove('in');
        document.body.classList.remove('modal-open');

        modal.dispatchEvent(new CustomEvent('custom-modal-hide', {detail: this.closeDataElement}));
        this.closeDataElement = null;
    }

    closeModal(modalId) {
        const myEvent = new CustomEvent('removeHistoryState', {
            'detail': {
                eventId: modalId
            }
        });
        document.dispatchEvent(myEvent);
    }


    removeVisibility(modal) {
        if (!modal.classList.contains('in')) {
            modal.classList.remove('custom-modal-open');
            modal.dispatchEvent(new Event('custom-modal-hidden'));
        }
    }

    _closeModalEvent(event) {
        let modalId = event.currentTarget.closest('[data-entity="custom-modal"]').getAttribute('id');

        if (this.closeImmediately && (!history.state || history.state.element !== '#' + modalId)) {
            this.closeAnimationModal('#' + modalId);
            return;
        }

        if (modalId) {
            this.closeModal('#' + modalId);
        }
    }

    setCustomParam(key, value) {
        this[key] = value;
    }
}

CustomModalManager.className = 'customModalManager';
